import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, ApplicationRef } from '@angular/core';
import { CERTIFICATE_LIST } from '../../community/roles/roles.model';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { User } from 'src/app/shareModule/models/user.model';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-advanced-settings-profile',
  templateUrl: './advanced-settings-profile.component.html',
  styleUrls: [
    './advanced-settings-profile.component.scss',
    '../advanced-settings.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedSettingsProfileComponent implements OnInit {

  public imgUrl = environment.ImageUrl;
  public showAvatarDropdown: boolean = false;
  public selectedAvatar: any = null;
  public readonly compressedImagePath = '/assets/images/profile-charactor/compressed/'
  public ROLES: any[] = CERTIFICATE_LIST;
  public charImage: any = {
    file: null,
    preview: null,
    default: false
  };
  public postalCode: string = '';
  public shortDescription: string = '';
  public certifiedSelect: any[] = [];

  public userInfo: any = {
    profileCharacterName: '',
    bgBody: '',
    numberOfDayForPostalCodeChange: 0,
    shortDescription: '',
    certifiedValue: [],
    region: '',
    regionName: '',
  };
  public currentPostalCode: string = '';

  constructor(
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
    private local: LocalServiceService,
    public roleService: RoleService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private store: Store<AppState>,
    private appRef: ApplicationRef // Added ApplicationRef
  ) { }

  public _roleSubscription? : Subscription = null
  ngOnInit(): void {
    this._roleSubscription?.unsubscribe();
    this._roleSubscription = this.roleService.rolesSubject.subscribe(()=>{
      this.showTheme =  this.roleService.roles?.level?.includes('MEMBER_SHOP_THEME');
      this.cdr.markForCheck();

    })

   
    this.store.pipe(select(selectUser)).subscribe((response: User) => {
      console.log("response", response, "PROFILE")
      try {
        if (response) {
       
          // this.getCertificate()
          const data = response;
          this.postalCode = data.postalCode;
          this.currentPostalCode = data.postalCode;
          this.shortDescription = data.shortDescription == 'null' ? '' : data.shortDescription;


          this.charImage.preview = this.imgUrl + data.characterImageUpload;
          this.charImage.default = data.useCharacterImage;
           
          let certs = []
          try{
            certs = JSON.parse(data?.certified ?? '[]')
          }catch(e){
            console.error(e)
          }
          this.userInfo = {
            profileCharacterName: data.profileCharacterName,
            bgBody: data.bgBody,
            numberOfDayForPostalCodeChange: 0,
            shortDescription: data.shortDescription,
            certifiedValue: certs,
            region: data.region,
            regionName: this.commonService.getSubRegionBaseOnPostalCode(
              data.postalCode || ''
            )?.name,
            theme: data.theme
          };
          this.commonService.setTheme(this.userInfo.theme)
          console.log({})

          this.cdr.detectChanges();
          this.appRef.tick();
        }
      } catch (error) {
        console.log("error", error, "PROFILE")
      }
    });
    this.getCertificate()
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }


  public isPostalConfirmed: boolean = false;
  public filterSubregions() {
    if (this.isPostalConfirmed) {
      this.isConfirm();
    } else {
      this.local
        .alertConfirm({
          message: `All Product will be Delisted, Are you sure want to change postal code ?`,
        })
        .then((resp) => {
          if (resp.isConfirmed) {
            this.isPostalConfirmed = true;
            this.isConfirm();
          } else {
            this.postalCode = this.currentPostalCode;
          }
          this.cdr.detectChanges();
          this.appRef.tick();
        });
    }
  }

  public isConfirm() {
    let region =
      this.commonService.getSubRegionBaseOnPostalCode(this.postalCode) || '';
    this.userInfo.regionName = region ? region.name : '';
    this.userInfo.region = region ? region.subRegionId : '';
    this.cdr.detectChanges();
    this.appRef.tick();
  }

  onCharImageChange(event: any) {

    this.charImage.file = null;
    this.charImage.preview = ''

    if (this.selectedAvatar) {
      fetch(this.compressedImagePath + this.selectedAvatar.image)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then(blob => {
          this.charImage.file = blob;
          this.charImage.default = true;
          this.charImage.preview = this.compressedImagePath + this.selectedAvatar.image;
          this.cdr.detectChanges();
          this.appRef.tick();
        })
        .catch(error => {
          console.error('Error converting selectedAvatar to blob:', error);
        });
    }
  }

  public showTheme = false;
  public getCertificate() {
    this.auth.certificateGet().subscribe((result) => {
      result.body.map((row) => {
        if (!this.certifiedSelect.some(item => item.value === row.role)) {
          this.certifiedSelect.push({
            value: row.role,
            label: row.role,
          });
        }
      });
      this.cdr.detectChanges();
      this.appRef.tick();
    })
  }

  updateCertificate(event: any): void {
    this.cdr.detectChanges();
    this.appRef.tick();
  }

  onThemeChange(event: any): void {
    const newValue = event.target.value;
    console.log({newValue})
    this.userInfo.theme = newValue
    this.cdr.detectChanges();
    this.appRef.tick();
  }

  onBgBodyChange(event: any): void {
    
    this.cdr.detectChanges();
    this.appRef.tick();
  }

  public saveProfileInfo(): void {

    let payload = this.userInfo;

    if (this.postalCode != this.currentPostalCode) {
      if (this.postalCode.length != 6) {
        this.toastr.error('Postal code should be 6 digits');
        return;
      }
      payload['postalCode'] = this.postalCode;
    }

    const formData = new FormData

    Object.keys(payload)
      .map((row) => {
        formData.append(row, payload[row])
      })

    this.auth.updateProfileCharacterDetails(formData).subscribe(
      (resp: ApiResponse) => {
        if (resp.message) {
          this.toastr.success(resp.message);
          this.store.dispatch(loadUser({}));
          this.cdr.detectChanges();
          this.appRef.tick();
         
        }
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }
}
